import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { PieceGrouped } from './pieceGrouped';
import { Piece } from './piece';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { PieceHistory } from './piece-history';

@Injectable()
export class InventoryService {
  //Use API
  private _url = this._configuration.apiUrl + "/v2/piece";
  private _historyUrl = this._configuration.apiUrl + "/v2/pieceHistory";
  private _groupedUrl = this._configuration.apiUrl + "/v2/pieceGrouped";
  private _inventoryUrl = this._configuration.apiUrl + "/v2/inventory";

  private headers: Headers;

  constructor(private _http: Http, private _configuration: Configuration, public _authService: AuthenticationService) {
  }

  getPiece(id: number, all: boolean): Observable<Piece[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._url;

    if (id > 0) {
      //s.append('id', id);
      fullUrl += "?id=" + id;
    }

    if (all) {
      s.append('all', 'true');
    }

    return this._http.get(fullUrl, { headers: h, search: s })
      .map((response: Response) => <Piece[]>response.json().pieces);
  }

  getPieceHistory(piece_number: string): Observable<PieceHistory[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._historyUrl;

    if (piece_number) {
      fullUrl += "?piece_number=" + piece_number;
    }

    return this._http.get(fullUrl, { headers: h, search: s }).map(
      (response: Response) => {
        console.log("history: " + response.toString());
        return <PieceHistory[]>response.json().history
      } 
      );
  }

  getPieceByPieceNumber(piece_number: string): Observable<{ id: number, piece_number: string }> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('piece_number', piece_number);

    return this._http.get(this._url, { headers: h, search: s }).map((response) => Object.assign(response.json(), { piece_number: piece_number }));
  }


  getPieces(branchId?: number, colorId?: number, fabricId?: number): Observable<Piece[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._url;
    s.append('includereserved', 'true');

    if (branchId > 0) {
      s.append('branch_id', branchId.toString());
    }

    if (colorId > 0) {
      s.append('color_id', colorId.toString());
    }

    if (fabricId > 0) {
      s.append('fabric_id', fabricId.toString());
    }

    

    return this._http.get(fullUrl, { headers: h, search: s })
      .map((response: Response) => {
        if (Array.isArray(response.json().pieces)) {
          return <Piece[]>response.json().pieces;
        } else {
          return <Piece[]>[];
        }
      });
  }

  getSoldPieces(customerId: number): Observable<Piece[]> {
    let h: Headers = this._authService.getHeaders();
    let _s: URLSearchParams = new URLSearchParams();

    _s.append('sold', 'true');
    _s.append('customer_id', customerId + '');

    return this._http.get(this._url, { headers: h, search: _s })
      .map((response: Response) => {
        if (Array.isArray(response.json().pieces)) {
          return <Piece[]>response.json().pieces;
        } else {
          return <Piece[]>[];
        }
      });
  }

  getPiecesGrouped(fabricTypeId: number, branchId: number): Observable<PieceGrouped[]> {

    console.log('service, getting');
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._groupedUrl;

    if (branchId > 0 && fabricTypeId > 0) {
      fullUrl += "?branch_id=" + branchId;
      fullUrl += "&fabric_type_id=" + fabricTypeId;
    } else if (fabricTypeId > 0) {
      fullUrl += "?fabric_type_id=" + fabricTypeId;
    } else if (branchId > 0) {
      fullUrl += "?branch_id=" + branchId;
    }

    return this._http.get(fullUrl, { headers: h, search: s })
      .map((response: Response) => <PieceGrouped[]>response.json().pieces);
  }

  getPiecesOrdered(fabricTypeId: number, branchId: number): Observable<PieceGrouped[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._groupedUrl;

    if (fabricTypeId > 0) {
      s.append('fabric_type_id', fabricTypeId + '');
    }
    if (branchId > 0) {
      s.append('branch_id', branchId + '');
    }

    s.append('ordered', 'true');

    return this._http.get(fullUrl, { headers: h, search: s })
      .map((response: Response) => <PieceGrouped[]>response.json().pieces);
  }

  getPiecesMissing(fabricTypeId: number, branchId: number): Observable<PieceGrouped[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._groupedUrl;

    if (fabricTypeId > 0) {
      s.append('fabric_type_id', fabricTypeId + '');
    }
    if (branchId > 0) {
      s.append('branch_id', branchId + '');
    }

    s.append('missing', 'true');

    return this._http.get(fullUrl, { headers: h, search: s })
      .map((response: Response) => <PieceGrouped[]>response.json().pieces);
  }

  getPiecesOrderedDetail(colorId: number, branchId: number): Observable<any[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._groupedUrl;

    if (colorId > 0) {
      s.append('color_id', colorId + '');
    }
    if (branchId > 0) {
      s.append('branch_id', branchId + '');
    }

    s.append('ordered_detail', 'true');

    return this._http.get(fullUrl, { headers: h, search: s }).map((response: Response) => response.json().pieces);
  }

  getPiecesMissingDetail(colorId: number, branchId: number): Observable<any[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._groupedUrl;

    if (colorId > 0) {
      s.append('color_id', colorId + '');
    }
    if (branchId > 0) {
      s.append('branch_id', branchId + '');
    }

    s.append('missing_detail', 'true');

    return this._http.get(fullUrl, { headers: h, search: s }).map((response: Response) => response.json().pieces);
  }

  getPiecesReservedDetail(colorId: number, branchId: number): Observable<any[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    let fullUrl = this._groupedUrl;

    if (colorId > 0) {
      s.append('color_id', colorId + '');
    }
    if (branchId > 0) {
      s.append('branch_id', branchId + '');
    }

    s.append('reserved_detail', 'true');

    return this._http.get(fullUrl, { headers: h, search: s }).map((response: Response) => response.json().pieces);
  }

  addPiece(p: Piece, external?: boolean): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (external != null) {
      s.append('external', external + '');
    }

    return this._http.post(this._url, p, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        body['piece_number'] = p.piece_number;
        return body;
      },
    ).catch(
      (error: any) => {
        return Observable.of({ piece_number: p.piece_number });
      }
    );
  }

  sellPiece(p: Piece) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', p.id + '');

    return this._http.put(this._url + '/sell', {}, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        body['piece_number'] = p.piece_number;
        return body;
      },
    ).catch(
      (error: any) => {
        return Observable.of({ piece_number: p.piece_number });
      }
    );
  }

  updatePiece(p: Piece) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', p.id + '');

    return this._http.put(this._url, p, { headers: h, search: s }).map(response => response.json());
  }

  refundPiece(p: Piece) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', p.id + '');

    return this._http.put(this._url + '/refund', {}, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        body['piece_number'] = p.piece_number;
        return body;
      },
    ).catch(
      (error: any) => {
        return Observable.of({ piece_number: p.piece_number });
      }
    );
  }

  // PDA Operations
  changeLocation(piece_no: string, new_location: string, branch_id: number) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'changeLocation');
    s.append('piece_number', piece_no);
    s.append('new_location', new_location);
    s.append('branch_id', branch_id + '');

    return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(response => response.json());
  }

  changePallet(piece_no: string, new_pallet: string, branch_id: number) {
     let h: Headers = this._authService.getHeaders();
     let s: URLSearchParams = new URLSearchParams();

     s.append('operation', 'changePallet');
     s.append('piece_number', piece_no);
     s.append('new_pallet', new_pallet);
     s.append('branch_id', branch_id + '');

     return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(response => response.json());
     }

  findProduct(color_id: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'findProduct');
    s.append('color_id', color_id);

    return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(
      response => {
        let body = response.json();

        if (body != null && Array.isArray(body['products'])) {
          return body['products'];
        } else {
          return [];
        }
      }
    );
  }

  findByPallet(palletName: string, branch_id: number) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'findByPallet');
    s.append('pallet_name', palletName);
    s.append('branch_id', branch_id + '');

    return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(
      response => {
        let body = response.json();

        if (body != null && Array.isArray(body['products'])) {
          return body['products'];
        } else {
          return [];
        }
      }
    );
  }

  findByPieceNumber(piece_number: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'findByPieceNumber');
    s.append('piece_number', piece_number);

    return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(response => response.json());
  }

  suggestNextNumber(piece_number: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'suggestNumber');
    s.append('piece_number', piece_number);

    return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(response => response.json());
  }

  findSimilar(piece_number: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'findSimilar');
    s.append('piece_number', piece_number);

    return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(
      response => {
        let body = response.json();

        if (body != null && Array.isArray(body['products'])) {
          return body['products'];
        } else {
          return [];
        }
      }
    );
  }

  cutPiece(piece_number: string, new_piece_number: string, old_length: number, new_length: number) {
    let h: Headers = this._authService.getHeaders();
    
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'cutPiece');
    s.append('piece_number', piece_number);
    s.append('new_piece_number', new_piece_number);
    s.append('old_length', old_length + '');
    s.append('new_length', new_length + '');
    s.append('user', this._authService.getUser().name);

    return this._http.put(this._inventoryUrl, {}, { headers: h, search: s }).map(response => response.json());
  }

  importPiece(p: Piece): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'importPiece');

    return this._http.put(this._inventoryUrl, p, { headers: h, search: s }).map(response => response.json())
      .catch(
        (error: any) => {
          return Observable.of({ piece_number: p.piece_number });
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/inventory/inventory.service.ts